import {
  DateFieldAbsoluteFilter,
  DateFieldFilter,
  DateFieldFilterOperationType,
  DateFieldRelativeFilter,
} from '../../filters/date';

export const isBasic = (value: DateFieldFilterOperationType) => {
  switch (value) {
    case DateFieldFilterOperationType.IsBeforeToday:
    case DateFieldFilterOperationType.IsToday:
    case DateFieldFilterOperationType.IsTomorrow:
    case DateFieldFilterOperationType.IsThisWeek:
    case DateFieldFilterOperationType.IsLastWeek:
    case DateFieldFilterOperationType.IsNextWeek:
    case DateFieldFilterOperationType.IsThisMonth:
    case DateFieldFilterOperationType.IsLastMonth:
    case DateFieldFilterOperationType.IsThisQuarter:
    case DateFieldFilterOperationType.IsLastQuarter:
    case DateFieldFilterOperationType.IsThisYear:
    case DateFieldFilterOperationType.IsAny:
      return true;
    default:
      return false;
  }
};

export const isRelative = (value: DateFieldFilterOperationType) => {
  switch (value) {
    case DateFieldFilterOperationType.IsMoreThan:
    case DateFieldFilterOperationType.IsExactly:
    case DateFieldFilterOperationType.IsLessThan:
      return true;
    default:
      return false;
  }
};

export const asRelative = (
  filter: DateFieldFilter,
): DateFieldRelativeFilter | null => {
  return isRelative(filter.type) ? (filter as any) : null;
};

export const isAbsolute = (value: DateFieldFilterOperationType) => {
  switch (value) {
    case DateFieldFilterOperationType.IsAfter:
    case DateFieldFilterOperationType.IsOn:
    case DateFieldFilterOperationType.IsBefore:
      return true;
    default:
      return false;
  }
};

export const asAbsolute = (
  filter: DateFieldFilter,
): DateFieldAbsoluteFilter | null => {
  return isAbsolute(filter.type) ? (filter as any) : null;
};

export const isOptional = (value: DateFieldFilterOperationType) => {
  switch (value) {
    case DateFieldFilterOperationType.IsEmpty:
    case DateFieldFilterOperationType.IsNotEmpty:
      return true;
    default:
      return false;
  }
};
